module.exports = __webpack_public_path__ + "img/polyglot-80.f5f608a1.png";